/* FC Store Locator — tabs, per-store photo slider, mobile tabs scroll indicator.
   Vanilla JS, no dependencies. Pairs with sections/fc-store-locator.liquid. */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function FCStoreLocator(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('.fc-store-locator__tab'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('.fc-store-locator__panel'));
    this.scroller = root.querySelector('.fc-store-locator__tabs');
    this.thumb = root.querySelector('.fc-store-locator__tabs-thumb');
    this.track = root.querySelector('.fc-store-locator__tabs-track');

    this.bindTabs();
    this.bindSliders();
    this.bindScrollIndicator();
  }

  FCStoreLocator.prototype.bindTabs = function () {
    var self = this;
    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        self.activate(index, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % self.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + self.tabs.length) % self.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = self.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        self.activate(next, true);
      });
    });
  };

  FCStoreLocator.prototype.activate = function (index, focus) {
    this.tabs.forEach(function (tab, i) {
      var selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
    this.panels.forEach(function (panel, i) {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    if (focus) this.tabs[index].focus();
    /* keep the active tab in view within the mobile scroller */
    this.tabs[index].scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
      behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
    });
  };

  FCStoreLocator.prototype.bindSliders = function () {
    this.panels.forEach(function (panel) {
      var slides = panel.querySelector('.fc-store-locator__slides');
      var nav = panel.querySelector('.fc-store-locator__nav');
      if (!slides || !nav) return;
      if (slides.children.length < 2) {
        nav.setAttribute('data-fc-sl-single', '');
        return;
      }
      var step = function (direction) {
        var width = slides.clientWidth;
        var max = slides.scrollWidth - width;
        var target = slides.scrollLeft + direction * width;
        /* wrap around at the ends */
        if (target > max + 1) target = 0;
        if (target < -1) target = max;
        slides.scrollTo({
          left: target,
          behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
        });
      };
      nav.querySelector('[data-fc-sl-prev]').addEventListener('click', function () {
        step(-1);
      });
      nav.querySelector('[data-fc-sl-next]').addEventListener('click', function () {
        step(1);
      });
    });
  };

  FCStoreLocator.prototype.bindScrollIndicator = function () {
    var scroller = this.scroller;
    var thumb = this.thumb;
    var track = this.track;
    if (!scroller || !thumb || !track) return;
    var update = function () {
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      if (ratio >= 0.999) {
        track.style.display = 'none';
        return;
      }
      track.style.display = '';
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var progress = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      thumb.style.width = ratio * 100 + '%';
      thumb.style.left = progress * (1 - ratio) * 100 + '%';
    };
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.fc-store-locator');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.fcInitialized) return;
      root.dataset.fcInitialized = 'true';
      root.fcStoreLocator = new FCStoreLocator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('.fc-store-locator') : null;
    var tab = root && root.querySelector('.fc-store-locator__tab[data-block-id="' + event.detail.blockId + '"]');
    if (root && tab && root.fcStoreLocator) {
      root.fcStoreLocator.activate(root.fcStoreLocator.tabs.indexOf(tab), false);
    }
  });
})();
